import { type ReactElement } from 'react'
import { Select } from '@mantine/core'
import { type WithProgramForm } from './type'

const PROGRAM_STATUS_OPTIONS = [
  { value: 'active', label: 'Active - Program will auto enroll users' },
  { value: 'inactive', label: 'Inactive - Program will not auto enroll users' },
]

export const ProgramStatusSelect = ({ form }: WithProgramForm): ReactElement => {
  return (
    <Select
      allowDeselect={false}
      data={PROGRAM_STATUS_OPTIONS}
      flex={1}
      label='Program Auto Enrollment'
      {...form.getInputProps('status')}
    />
  )
}
